document.addEventListener('alpine:init', () => {
    Alpine.data('predictiveSearchComponent', () => ({
        loading: false,
        results: '',
        onChange(e) {
            const query = e.target.value.trim();
            if (!query) {
                this.results = '';
                return;
            }
            this.loading = true;

            fetch(
                `${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(
                    query
                )}&resources[type]=product,query,collection,page,article&section_id=predictive-search`
            )
                .then((res) => {
                    if (!res.ok) throw new Error(res.status);
                    return res.text();
                })
                .then((text) => {
                    const html = new DOMParser()
                        .parseFromString(text, 'text/html')
                        .querySelector('#shopify-section-predictive-search').innerHTML;
                    this.results = html;
                })
                .catch((err) => {
                    console.error(err);
                    this.results = '';
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    }));
});